import { useEffect } from "react";

export const generateRandomNumber = (number: number) => {
    const crypto = window.crypto || (window as any).msCrypto;
    const randomValues = new Uint32Array(1);
    crypto.getRandomValues(randomValues);
    return randomValues[0] % number
}

export const useHandleClickOutside = (
    condition: boolean,
    callback: () => void,
    targetClass: string
  ) => {
    useEffect(() => {
      if (condition) {
        const handleClick = (e: any) => {
          if (e.target.className && e.target.className.indexOf(targetClass) === -1) {
            callback();
          }
        };
        
        window.addEventListener("click", handleClick);
        
        return () => {
          window.removeEventListener("click", handleClick);
        };
      }
    }, [condition, targetClass, callback]);
  };